export { en } from "./translations/en";
export { ar } from "./translations/ar";
export type { Translations } from "./translations/en";

import { en } from "./translations/en";
import { ar } from "./translations/ar";
import type { Translations } from "./translations/en";

export type Locale = "en" | "ar";

export const locales: Record<Locale, Translations> = { en, ar };

export function getTranslations(locale: Locale): Translations {
  return locales[locale];
}
